import { render, staticRenderFns } from "./module-price.vue?vue&type=template&id=bf7cdad0&scoped=true"
import script from "./module-price.vue?vue&type=script&lang=js"
export * from "./module-price.vue?vue&type=script&lang=js"
import style0 from "./module-price.vue?vue&type=style&index=0&id=bf7cdad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7cdad0",
  null
  
)

export default component.exports